module.exports = "<div [ngClass]=\"show?'spinner-wrap local active':'spinner-wrap local'\">\r\n  <div class=\"spinner\"></div>\r\n</div>"